<template lang="pug">
  .tabs-layout
    .tabs
      ul.tabs__list
        li.tabs__item(
          v-for="(tab, index) in options"
          :key="index"
          :class="{ 'tabs__item--active': $route.path.split('?')[0] === tab.path.split('?')[0] }"
          @click="handleTabClick(tab)"
        )
          router-link.tabs__link(:to="getTabTo(tab)" exact-active-class="router-link-exact-active")
            | {{ tab.title | translate }}
  </template>
  
  <script>
  export default {
    name: 'VNavTabs',
  
    props: {
      options: Array
    },
  
    methods: {
      handleTabClick (tab) {
        this.$emit('tab-click', tab)
      },

      getTabTo (tab) {
        const tabPath = tab.path.split('?')[0]
        if (tabPath === this.$route.path) {
          return { path: tabPath, query: this.$route.query }
        }
        return tab.path
      }
    }
  }
  </script>